import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, X } from 'lucide-react';

// Renders a small toast when a new service worker is waiting to activate.
// Clicking Refresh tells the SW to skipWaiting + reloads the page so the
// user picks up the new bundle immediately. Without this, vite-plugin-pwa's
// 'autoUpdate' just registers the new SW silently and waits for the user
// to navigate away, leaving open tabs on the stale build for hours.
export default function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    // Re-check for an updated SW once an hour while the tab is open.
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      const HOUR = 60 * 60 * 1000;
      setInterval(() => { registration.update().catch(() => {}); }, HOUR);
    },
    onRegisterError(err) {
      console.warn('[sw] register error', err);
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-14 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-[#15181C] border border-emerald-500/30 rounded-xl shadow-xl px-4 py-2.5">
      <span className="text-xs text-[#F0F2F4] font-medium">A new version is available</span>
      <button
        onClick={() => updateServiceWorker(true)}
        className="flex items-center gap-1.5 text-xs font-semibold bg-emerald-600 hover:bg-emerald-500 text-white px-3 py-1.5 rounded-lg transition"
      >
        <RefreshCw size={12} />
        Refresh
      </button>
      <button
        onClick={() => setNeedRefresh(false)}
        className="text-[#9ba3b0] hover:text-[#c7ccd4] transition"
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
